module.exports = __webpack_public_path__ + "static/media/logo.5e19b6c5.svg";